import Router from './routes/Router';
import UserProvider from './contexts/UserContext';
import PostsProvider from './contexts/PostContext';

function App() {
  return (
    <UserProvider>
      <PostsProvider>
        <Router />
      </PostsProvider>
    </UserProvider>
  );
}

export default App;
